interface ArrowCircleIconProps {
  size?: number;
  direction?: "up" | "down" | "left" | "right";
}

const ArrowCircleIcon = ({
  size = 16,
  direction = "down",
}: ArrowCircleIconProps) => {
  const rotateMap = {
    up: "rotate(180 8 8)",
    down: "rotate(0 8 8)",
    left: "rotate(90 8 8)",
    right: "rotate(-90 8 8)",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />

      <g transform={rotateMap[direction]}>
        <path
          d="M5.75 7.25L8 9.75L10.25 7.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default ArrowCircleIcon;
